import { REDUX_ACTIONS, GAME_ID, MASTERY_SCORE } from 'a/storybox/data/constants';

const initState = {
  score: 0,
  charactersPlayed: [],
  settingsPlayed: [],
  settingsUnlocked: [0, 1, 2],
  charactersUnlocked: [0, 1, 2],
};

const levelDetails = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }
  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return initState;

    case REDUX_ACTIONS.INCREMENT_LEVEL_SCORE:
      return {
        ...state,
        score: state.score + 1,
      };

    case REDUX_ACTIONS.MAX_LEVEL_SCORE:
      return {
        ...state,
        score: MASTERY_SCORE,
      };

    case REDUX_ACTIONS.STORY_CHOICE_SELECTION:
      if (payload.type === 'setting') {
        return {
          ...state,
          settingsPlayed: [
            ...state.settingsPlayed,
            payload.index,
          ],
        };
      }
      return {
        ...state,
        charactersPlayed: [
          ...state.charactersPlayed,
          payload.index,
        ],
      };

    default:
      return state;
  }
};

export default levelDetails;
